import React, { useEffect, useState } from 'react';



function ItemInfo({ filterdata}) {
  



      return (
        <div className="content-element">
         {filterdata && filterdata !== "" ? (
          <div className="d-flex justify-content-end ips-flex-row flex-row ips-content-iteminfo" dangerouslySetInnerHTML={{ __html: filterdata }}></div>
        ) : (
          <></>
        )}
      </div>

      );
    
  }


export default ItemInfo;